import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export function useSearchParams() {
	const { search } = useLocation();

	return useMemo(() => new URLSearchParams(search), [search]);
}

export function useTryParseRouteId(str: string) {
	return useMemo(() => {
		const parsed = parseInt(str);
		return isNaN(parsed) ? 0 : parsed;
	}, [str]);
}
